module.exports = flarum.extensions['fof-masquerade'];